(function ($, Drupal) {
  Drupal.behaviors.articlesCarousel = {
    attach: function (context, settings) {
      $(once('init-block-articles-carousel', '.block-articles-carousel', context))
        .each(function () {
          const contentArticlesCarousel = $(this);
          const contentArticlesCarouselSelector = contentArticlesCarousel.find(
            '.swiper-container',
            context
          );
          const contentArticlesCarouselSliderCount =
            contentArticlesCarousel.data('slider-conf-count');
          if (contentArticlesCarouselSelector.length) {
            let sliderOptions = {
              loop: true,
              navigation: {
                nextEl: '.ts-nav-next',
                prevEl: '.ts-nav-prev',
              },
              pagination: {
                el: '.swiper-pagination',
              },
              // Responsive breakpoints
              breakpoints: {
                320: {
                  slidesPerView: 1,
                  slidesPerGroup: 1,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              },
            };

            // First thing we need to fetch slider settings from data attributes.
            new Swiper(contentArticlesCarouselSelector[0], sliderOptions);
          }
        });
    },
  };


  Drupal.behaviors.articlesGridModule = {
    attach: function (context, settings) {
      $(once(
          'init-block-articles-grid-module',
          '.block-articles-grid-module',
          context
      )).each(function () {
        const block = $(this);

        const swiperEl = block.find('.swiper-container').first();

        if (!swiperEl.length) {
          return;
        }

        const fieldItems = swiperEl.find(
            '> .field--name-field-select-article.field__items'
        );

        if (!fieldItems.length) {
          return;
        }

        // Drupal field wrapper -> Swiper wrapper.
        fieldItems.addClass('swiper-wrapper');

        // Drupal field items -> Swiper slides.
        fieldItems.children('.field__item').addClass('swiper-slide');

        const nextEl = block.find('.ts-nav-next')[0];
        const prevEl = block.find('.ts-nav-prev')[0];
        const paginationEl = block.find('.swiper-pagination')[0];

        const sliderOptions = {
          loop: true,

          pagination: {
            el: paginationEl,
            clickable: true,
          },

          breakpoints: {
            320: {
              slidesPerView: 1.1,
              slidesPerGroup: 1,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 20,
            },
            991: {
              slidesPerView: 3,
              slidesPerGroup: 1,
              spaceBetween: 20,
            },
          },
        };

        if (nextEl && prevEl) {
          sliderOptions.navigation = {
            nextEl: nextEl,
            prevEl: prevEl,
          };
        }

        new Swiper(swiperEl[0], sliderOptions);
      });
    },
  };
})(jQuery, Drupal);
